export default __webpack_public_path__ + "static/media/two-sixths.828ab9bd.svg";